// extracted by mini-css-extract-plugin
module.exports = {"page":"PlayerList_page__2x7Ny","mainTable":"PlayerList_mainTable__2nPqk","subBtnStyle":"PlayerList_subBtnStyle__2e6a2","inputStyle":"PlayerList_inputStyle__2JSKr"};